/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import {
    IAgentPlugin,
    IPluginMethodMap,
} from "@vlinder-web/plugin-agent-service-react";
import { GraphqlServerModule } from "@vlinder-web/graphql-server-module-react";
import { FEATURE_INVENTORY_REPORT } from "../graphql/featureReport.query";
import { VApplication } from "../../../application";
import moment from "moment";

const is = require("is_js");

const getGraphQLModule = () => {
    const app = VApplication.getInstance();
    return app.getSync("services.GraphqlServerModule") as GraphqlServerModule;
};

export interface IGetFeatureReportMethods extends IPluginMethodMap {
    getFeatureReport(args: any): Promise<any>;
}

export class GetFeatureReportService implements IAgentPlugin {
    readonly methods: IGetFeatureReportMethods;

    constructor() {
        this.methods = {
            getFeatureReport: this.getFeatureReport.bind(this),
        };
    }

    async getFeatureReport(args: any) {
        const graphqlModule = getGraphQLModule();
        const client = graphqlModule.getClient("graphql-gateway");
        console.log("filet apply====", args);
        let variables = {
            filters: {
                presentation: {
                    eq: args?.presentation,
                },
                name: {
                    eq: args?.name
                }
            },
        };
        console.log("filter in full payment user", variables);
        try {
            if (client) {
                const res = await client.query({
                    query: FEATURE_INVENTORY_REPORT,
                    variables: variables,
                    fetchPolicy: "network-only",
                });
                return res
            }
        } catch (err: any) {
            let _display_message =
                err?.graphQLErrors &&
                Array.isArray(err?.graphQLErrors) &&
                err?.graphQLErrors.find((item: any) => item.extensions);
            if (_display_message?.extensions?.display_message) {
                throw Error(_display_message?.extensions?.display_message);
            }

            throw err;
        }
    }

}
